import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-controlpanel',
  templateUrl: './controlpanel.component.html',
  styleUrls: ['./controlpanel.component.css']
})
export class ControlpanelComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportControlPanel/Post';
        this.header = {};
        this.zones = [];
        this.rows = [];
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Zone: null,
            //Date: this.f_datefrom
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.header = rs.header;
                
                if( Array.isArray(rs.detail) && (rs.detail.length > 0) ){
                    this.rows = rs.detail[0];

                    this.rows.ventaNetaSemaforoTT = this.getColorOther(this.rows.ventaNetaCumpliTT);
                    this.rows.ventaNetaSemaforoMes = this.getColorOther(this.rows.ventaNetaCumpliMes);

                    this.rows.cobranzaSemaforo = this.getColorOther(this.rows.cobranzaCumpli);
                    this.rows.efectividadSemaforo = this.getColor(this.rows.efectividadVentaCumpli);

                    this.rows.margenVentaSemaforo = this.getColorOther(this.rows.margenVentaCumpli);
                    this.rows.devVentaSemaforo = this.getColorOther(this.rows.devVentaCumpli);
                    this.rows.clienteSinVentaSemaforo = this.getColorOther(this.rows.clienteSinVentaCumpli);
                    this.rows.margenCobradoSemaforo = this.getColorOther(this.rows.margenCobradoCump);
                }
            }
        });
    }

    getColor(par:any){
        var r:any;
        par = parseFloat(par.replace(/,/g, ''));
        r = {};

        //if(par <= 80){
        if(par < 54){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        //else if(par > 95){
        else if(par >= 60){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    getColorOther(par:any){
        var r:any;
        par = parseFloat(par.replace(/,/g, ''));
        r = {};

        if(par <= 80){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if(par > 95){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'TABLERO DE CONTROL (VENDEDOR)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Fecha: ' + this.today, colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'Mes: ' + this.f_datefrom, colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let footer = [];
        let x = [];
        let i = this.rows;

        header = [];
        header.push(['VARIABLES DE PAGO', 'REAL', 'OBJ TIEMPO TRANSCURRIDO', '% CUMP TT', '', 'OBJ MES', '%CUMP MES', '']);
        
        x = [];
        x.push([
            'VENTAS NETAS',
            '$ '+i.ventaNetaReal,
            '$ '+i.ventaNetaObjetivoTT,
            i.ventaNetaCumpliTT + ' %',
            {content:'', styles:{fillColor:i.ventaNetaSemaforoTT.color, cellWidth:15}},
            '$ '+i.ventaNetaObjetivoMes,
            i.ventaNetaCumpliMes + ' %',
            {content:'', styles:{fillColor:i.ventaNetaSemaforoMes.color, cellWidth:15}},
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fillColor:'#3e5569', halign:'center'}, bodyStyles:{halign:'center'}});

        header = [];
        header.push(['VARIABLES DE PAGO', 'REAL', 'OBJETIVO', '% CUMP', '']);
        
        x = [];
        x.push([
            'COBRANZA CON IVA',
            '$ '+i.cobranzaReal,
            '$ '+i.cobranzaObjetivo,
            i.cobranzaCumpli + ' %',
            {content:'', styles:{fillColor:i.cobranzaSemaforo.color, cellWidth:15}}
        ]);
        x.push([
            'COBRANZA SIN IVA',
            '$ '+i.cobranzaSinIVA,
            '$ '+i.cobranzaObjetivoSinIVA,
            i.cobranzaCumpliSinIVA + ' %',
            {content:'', styles:{fillColor:i.cobranzaSemaforo.color, cellWidth:15}}
        ]);

        x.push([
            'EFECTIVIDAD VENTAS MES',
            i.efectividadVentaReal,
            i.efectividadVentaObjetivo,
            i.efectividadVentaCumpli + ' %',
            {content:'', styles:{fillColor:i.efectividadSemaforo.color, cellWidth:15}}
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fillColor:'#3e5569', halign:'center'}, bodyStyles:{halign:'center'}});

        header = [];
        header.push(['VARIABLES GESTION', 'REAL', 'OBJETIVO', '% CUMP', '']);

        x = [];
        x.push([
            '% MARGEN VENTA',
            i.margenVentaReal + ' %',
            i.margenVentaObjetivo + ' %',
            i.margenVentaCumpli + ' %',
            {content:'', styles:{fillColor:i.margenVentaSemaforo.color, cellWidth:15}}
        ]);

        x.push([
            '% DEV/VTAS',
            i.devVentaReal + ' %',
            i.devVentaObjetivo + ' %',
            i.devVentaCumpli + ' %',
            {content:'', styles:{fillColor:i.devVentaSemaforo.color, cellWidth:15}}
        ]);

        x.push([
            '# CLIENTE SIN VTA > 3 MESES',
            i.clienteSinVentaReal,
            i.clienteSinVentaObjet,
            i.clienteSinVentaCumpli + ' %',
            {content:'', styles:{fillColor:i.clienteSinVentaSemaforo.color, cellWidth:15}}
        ]);

        x.push([
            '$ MARGEN COBRADO',
            '$ '+i.margenCobradoReal,
            '$ '+i.margenCobradoObjetivo,
            i.margenCobradoCump + ' %',
            {content:'', styles:{fillColor:i.margenCobradoSemaforo.color, cellWidth:15}}
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fillColor:'#3e5569', halign:'center'}, bodyStyles:{halign:'center'}});
        
        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('tablero_de_control_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
